import * as R from 'ramda';
import { useEffect, useState} from 'react';
import MessageSendForm from "../../forms/MessageSendForm";
import { getMessageTemplates, sendEmailMessage } from '../../util/api';
import LoadingModal from '../dumb/LoadingModal';
import MessageTemplateDisplay from '../dumb/MessageTemplateDisplay';
import NotificationDisplay from '../dumb/NotificationDisplay';

function validEmail(email){
    const regex = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
    return regex.test(email);
}


function MessageSendComponent() {
    const [templates, setTemplates] = useState([]);
    const [error, setError] = useState(undefined);
    const [message, setMessage] = useState(undefined);
    const [notification, setNotification] = useState(undefined);
    const [emails, setEmails] = useState('');
    const [selectedTemplateId, setSelectedTemplateId] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(undefined)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getMessageTemplates()
        .then(templates =>  {
            setTemplates(templates);
            setLoading(false);
            setSelectedTemplateId(templates[0].templateId);
        })
        .catch(error => {
            console.error(`error = ${error}`);
            setLoading(false);
        })
    }, []);

    useEffect(() => {
        let errorFound = false;
        if (emails.length > 1) {
            let emailSplit = emails.split('\n');
            // Validate the emails
            emailSplit.forEach(email => {
                if (!validEmail(email)) {
                    if (!errorFound) {
                        setMessage(undefined);
                        setError(`${email} is invalid! Please correct the emails before proceeding`);
                        errorFound = true;
                    }
                }
            });
            if (!errorFound) {
                setError(undefined);
                setMessage('All emails are valid!')
            }
        }
        else {
            setError('No emails found! Please enter at least one email');
            setMessage(undefined);
        }
    }, [emails])

    useEffect(() => {
        let selectedTemplate = templates.filter(template => template.templateId === selectedTemplateId)[0];
        setSelectedTemplate(selectedTemplate);
    }, [selectedTemplateId]);

    return (
        <div>
            {
                !R.isNil(notification)
                && (
                    <NotificationDisplay notificationText={notification} close={() => setNotification(undefined)} />
                )
            }
            {
                !R.isNil(error)
                && <div style={{ color: 'red'}}> { error } </div> 
            }
            {
                !R.isNil(message)
                && <div style={{ color: 'green' }}> { message} </div>
            }
            <div style={{ marginTop: '50px', display: 'flex', justifyContent: 'flex-start' }}>
                
                <MessageSendForm
                    templates={templates}
                    emails={emails}
                    setEmails={emails => setEmails(emails)}
                    selectedTemplateId={selectedTemplateId}
                    setSelectedTemplateId={templateId => setSelectedTemplateId(templateId)}
                    error={error}
                    onClick={() => {
                        let emailSplit = emails.split('\n');
                        setLoading(true);
                        sendEmailMessage(emailSplit, selectedTemplateId)
                        .then((result) => {
                            setMessage(`${JSON.stringify(result)}`);
                            setLoading(false);
                            setNotification('Mails Sent!');
                        })
                        .catch((error) => {
                            console.error(`error = ${error}`);
                            setLoading(false);
                        });
                    }}
                />
                { !R.isNil(selectedTemplate) && (
                        <MessageTemplateDisplay
                            templateContent={selectedTemplate.templateContent}
                            params={''}
                            paramValues={''}
                        />
                    )
                }
                {
                    loading && (
                        <LoadingModal />
                    )
                }
            </div>
        </div>
    );
}

export default MessageSendComponent;